
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import Layout from "./components/Layout";
import Footnote from "./components/Footnote";
import Progress from "./components/Progress";
import {
  ORANGE,
  BRIGHT_ORANGE,
  MAROON,
  BLUE,
  BRIGHT_BLUE,
  GREEN,
  LIGHT_GREEN,
  BLACK,
  WHITE,
  GREY,
  LIGHT_GREY,
  DARK_GREY,
} from "./components/Colours.js";
import Brett from "./images/brett.jpg";
import RebelLogo from "./images/Rebel-com-large-white.png";
import Internet from "./images/original-seven-layers-of-osi-model.png";
import SocialMedia from "./images/social-media.jpg";
import ImpactDaos from "./images/impact-daos.png";
import Decentraland from "./images/decentraland.jpg";
import Cryptovoxels from "./images/cryptovoxels.gif";
import MyNfts from "./images/my-nfts.png";
import CityLights from "./images/citylights.png"
import MakerDao from "./images/makerdao.png"
import Toucan from "./images/toucan.png"
import Nori from "./images/nori.png"
export { default as theme } from "./components/Theme";
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Footer = makeShortcode("Footer");
const Image = makeShortcode("Image");
const Split = makeShortcode("Split");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Footer mdxType="Footer">
      <Progress mdxType="Progress" />
    </Footer>
    <Layout color={DARK_GREY} mdxType="Layout">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Key`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Left Arrow, Page Up, Shift + Space`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Go to previous slide`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Right Arrow, Page Down, Space`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Go to next slide`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Option + P`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Toggle Presenter Mode`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Option + O`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Toggle Overview Mode`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Option + G`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Toggle Grid Mode`}</td>
          </tr>
        </tbody>
      </table>
      <p><a parentName="p" {...{
          "href": "https://github.com/tackaberry/impact-hub-bbl-web3-intro"
        }}>{`This presentation on github`}</a></p>
    </Layout>
    <hr></hr>
    <Layout color={DARK_GREY} mdxType="Layout">
      <h1>{`Web3: Crypto, Metaverse and NFTs - What is it and how it is going to be used for good (working title)`}</h1>
      <h3>{`For Impact Hub `}<em parentName="h3">{`Brown Bag Lunch`}</em>{` Series`}</h3>
      <h3>{`June 9, 2022`}</h3>
      <h2>{`Brett Tackaberry, CTO`}</h2>
      <Image src={RebelLogo} style={{
        height: "100px",
        width: "450px"
      }} mdxType="Image" />
    </Layout>
    <hr></hr>
    <Layout color={BLUE} mdxType="Layout">
      <Split mdxType="Split">
        <Image src={Brett} style={{
          height: "600px",
          width: "600px"
        }} mdxType="Image" />
        <h1>{`About me`}</h1>
        <p>{`help people do awesome things with technology`}</p>
        <p>{`help companies grow, help teams do better`}</p>
        <p>{`use technology make the world a better place`}</p>
      </Split>
    </Layout>
    <hr></hr>
    <Layout color={BLUE} mdxType="Layout">
      <Image src={RebelLogo} style={{
        height: "100px",
        width: "450px"
      }} mdxType="Image" />
      <ul>
        <li parentName="ul">{`Sell domain names, websites, hosting, ecommerce, email`}</li>
        <li parentName="ul">{`Help small businesses across Canada succeed online`}</li>
        <li parentName="ul">{`In business in Ottawa for 20+ years`}</li>
      </ul>
    </Layout>
    <hr></hr>
    <Layout color={ORANGE} mdxType="Layout">
      <div style={{
        width: "900px",
        fontColor: "white"
      }}>
        <h1>{`web3: Crypto, Metaverse and NFTs - What is it and how it will be used for good`}</h1>
      </div>
    </Layout>
    <hr></hr>
    <Layout color={LIGHT_GREEN} light mdxType="Layout">
      <h1>{`🌞 gm 🌈`}</h1>
    </Layout>
    <hr></hr>
    <Layout color={MAROON} mdxType="Layout">
      <h1>{`Why? Why now?`}</h1>
      <p>{`If this is the future... We're at an inflection point`}</p>
      <p>{`The technology is growing past financial origins... `}</p>
      <p>{`Need to stay current`}</p>
      <p>{`why does it matter.... decentralized networks offer an alternative to the status quo`}</p>
    </Layout>
    <hr></hr>
    <Split mdxType="Split">
      <Layout twocolumn mdxType="Layout">
        <h4>{`web3 is an emerging structure for the next generation of the internet`}</h4>
      </Layout>
      <Layout twocolumn left color={WHITE} light mdxType="Layout">
        <ul>
          <li parentName="ul">{`decentralized`}</li>
          <li parentName="ul">{`trustless`}</li>
          <li parentName="ul">{`immutability`}</li>
          <li parentName="ul">{`verification`}</li>
          <li parentName="ul">{`transparent`}</li>
        </ul>
      </Layout>
    </Split>
    <hr></hr>
    <Layout color="GREEN" mdxType="Layout">
      <h1>{`web3 (vs web2 vs web1)`}</h1>
      <h2>{`Web3 is the internet owned by the builders and users, orchestrated with tokens`}</h2>
      <h2>{`web3 has native payments`}</h2>
    </Layout>
    <hr></hr>
    <Split mdxType="Split">
      <Layout twocolumn image={Internet} mdxType="Layout">
      </Layout>
      <Layout twocolumn color={WHITE} light mdxType="Layout">
        <p>{` the internet protocols are naturally open - tcp, ip, http, smtp - html, css, `}</p>
      </Layout>
    </Split>
    <hr></hr>
    <Split mdxType="Split">
      <Layout twocolumn image={SocialMedia} mdxType="Layout">
      </Layout>
      <Layout twocolumn color={WHITE} light mdxType="Layout">
        <p>{` companies monetized the last era of the web by wrapping software around these protocols and closing them off within their apps`}</p>
      </Layout>
    </Split>
    <hr></hr>
    <Split mdxType="Split">
      <Layout twocolumn image={SocialMedia} mdxType="Layout">
      </Layout>
      <Layout twocolumn color={BLACK} mdxType="Layout">
        <p>{` these apps have helped many people and organizations get access to powerful technologies, some free, some paid but the future direction of these networks is unilaterally decided by the companies`}</p>
      </Layout>
    </Split>
    <hr></hr>
    <Layout color={BRIGHT_BLUE} serif mdxType="Layout">
      <h1>{`Definitions`}</h1>
    </Layout>
    <hr></hr>
    <Layout color={WHITE} serif light leftTitle mdxType="Layout">
      <h1>{`Blockchain`}</h1>
      <p>{`A shared (no owner), distributed database that stores data in blocks that are ultimately linked together using cryptography, making verification easy and transparent`}</p>
      <p>{`different blockchains: Bitcoin, Ethereum`}</p>
    </Layout>
    <hr></hr>
    <Layout color={WHITE} serif light leftTitle mdxType="Layout">
      <h2>{`Blockchain is like the operating system`}<br />{`we need apps to make it useful`}</h2>
      <p>{`while it may seem like early days, the foundation is solid - `}<br />{`the rules, protocols, governance -`}<br />{` everyone knows the rules and the protocols are open to anyone`}</p>
    </Layout>
    <hr></hr>
    <Layout color={WHITE} serif light leftTitle mdxType="Layout">
      <h1>{`Metaverse`}</h1>
      <p>{`An immersive, iteractive virtual world when combined with blockchain technology provides a platform for application, games and virtual place-based activity`}</p>
      <p>{`You can actually own the items you earn - or land you buy`}</p>
    </Layout>
    <hr></hr>
    <Layout color={WHITE} serif light leftTitle mdxType="Layout">
      <h1>{`Cryptocurrency`}</h1>
      <p>{`A tradable digital asset or currency, built on blockchain technology. Uses encryption to authenticate and protect transactions. `}</p>
      <p>{`Examples: Ether on the Ethereum blockchain, Bitcoin, Doge`}</p>
      <p>{`Buy and trade: Coinbase, Coinsquare, Kraken plus many more`}</p>
    </Layout>
    <hr></hr>
    <Layout color={WHITE} serif light leftTitle mdxType="Layout">
      <h1>{`Tokens`}</h1>
      <p>{`A token is something specific like an asset that run's on top of another cryptocurrency's blockchain. There can be many different tokens on a coin on a blockchain. Bitcoin doesn't have this capability.  Stored in Wallets. `}</p>
    </Layout>
    <hr></hr>
    <Layout color={WHITE} serif light leftTitle mdxType="Layout">
      <h1>{`NFTs (non-fungible tokens)`}</h1>
      <p>{`A financial security consisting of digital data stored on the bloackchain. NFTs give users the ability to own objects, which can be art, photos, code, music, text, game objects, credentials, governance rights, access passes, and whatever else people dream up next.`}</p>
    </Layout>
    <hr></hr>
    <Layout color={WHITE} light mdxType="Layout">
      <h1>{`My NFTs`}</h1>
      <img src={MyNfts} style={{
        width: "1200px",
        height: "600px"
      }} />
    </Layout>
    <hr></hr>
    <Split mdxType="Split">
      <Layout twocolumn image={CityLights} mdxType="Layout">
      </Layout>
      <Layout twocolumn color={BLACK} mdxType="Layout">
        <h1>{`Citylights #231`}</h1>
        <p>{`by EEPMON`}</p>
      </Layout>
    </Split>
    <hr></hr>
    <Split mdxType="Split">
      <Layout twocolumn mdxType="Layout">
        <video loop="" autoplay="" playsinline="" preload="auto"><source src="https://assets.nbatopshot.com/editions/2_2021_nba_playoffs_common/b81087be-3d6f-4f9e-ac84-a3fb70b0fc05/play_b81087be-3d6f-4f9e-ac84-a3fb70b0fc05_2_2021_nba_playoffs_common_capture_Animated_1080_1920_Black.mp4" type="video/mp4" /></video>
      </Layout>
      <Layout twocolumn color={BLACK} mdxType="Layout">
        <h1>{`NBA Tops Shots`}</h1>
        <p><a parentName="p" {...{
            "href": "https://nbatopshot.com/"
          }}>{`https://nbatopshot.com/`}</a></p>
        <p>{`by `}<a parentName="p" {...{
            "href": "https://www.dapperlabs.com/"
          }}>{`https://www.dapperlabs.com/`}</a></p>
      </Layout>
    </Split>
    <hr></hr>
    <Layout color={BLACK} courier green mdxType="Layout">
      <h1>{`アサadタナ+=ハマヤdャラワガザダdバパイィキニヒ`}</h1>
      <h1>{`ダバxパイGシ  Let's go deeper...  ヰァAカサヰ`}</h1>
      <h1>{`マヤャ00ラ*$%ワザダバパ11イィアミ-リ35ヰァカハ`}</h1>
    </Layout>
    <hr></hr>
    <Layout color={BRIGHT_BLUE} mdxType="Layout">
      <h1>{`DAOs and DApps`}</h1>
    </Layout>
    <hr></hr>
    <Layout color={ORANGE} mdxType="Layout">
      <h1>{`DAO (Decentralized Autonomous Organization)`}</h1>
      <ul>
        <li parentName="ul">{`organization constructed by rules that are transparent and governed by members`}</li>
        <li parentName="ul">{`governed by the token holders - token is your membership`}</li>
        <li parentName="ul">{`play-to-earn games, get paid - just by holding, you get paid`}</li>
      </ul>
    </Layout>
    <hr></hr>
    <Layout color={ORANGE} mdxType="Layout">
      <h1>{`DAO (Decentralized Autonomous Organization)`}</h1>
      <ul>
        <li parentName="ul">{`YOU CAN PARTICIPATE `}</li>
        <li parentName="ul">{`Participate in DAOs, get on web3 twitter`}</li>
        <li parentName="ul">{`Purchase NFTs, publish Content`}</li>
        <li parentName="ul">{`Get your ENS domain name`}</li>
      </ul>
    </Layout>
    <hr></hr>
    <Layout color={ORANGE} mdxType="Layout">
      <h1>{`DApp (Decentralized Applications)`}</h1>
      <ul>
        <li parentName="ul">{`Ethereum is a programmable blockchain`}</li>
        <li parentName="ul">{`Enables Games and Metaverse`}</li>
        <li parentName="ul">{`Enables DeFi, NFTs, ReFi`}</li>
      </ul>
    </Layout>
    <hr></hr>
    <Split mdxType="Split">
      <Layout twocolumn image={Decentraland} mdxType="Layout">
      </Layout>
      <Layout twocolumn color={BLACK} mdxType="Layout">
        <h1>{`Decentraland`}</h1>
        <p>{`Marketplace, avatars, digital assets, land, content`}</p>
        <p><a parentName="p" {...{
            "href": "https://decentraland.org/"
          }}>{`https://decentraland.org/`}</a></p>
      </Layout>
    </Split>
    <hr></hr>
    <Split mdxType="Split">
      <Layout twocolumn image={Cryptovoxels} mdxType="Layout">
      </Layout>
      <Layout twocolumn color={BLACK} mdxType="Layout">
        <h1>{`Cryptovoxels`}</h1>
        <p>{`Buy parcels, create a space, put your art on the wall`}</p>
        <p><a parentName="p" {...{
            "href": "https://www.cryptovoxels.com/"
          }}>{`https://www.cryptovoxels.com/`}</a></p>
      </Layout>
    </Split>
    <hr></hr>
    <Split mdxType="Split">
      <Layout twocolumn mdxType="Layout">
        <video autoplay="" style={{
          width: 400,
          height: 600
        }} class="AssetMedia--video" controls="" controlslist="nodownload" loop="" playsinline="" poster="https://lh3.googleusercontent.com/i34hxbaGid5dAZxzvHuRcwCqxB445g3_HJRe61oVVg27kpLINAc9qslA3Pug32wH3P9My0x_q0xZj-62SJqyiHM1MaCfsT0jkjgaeQ" preload="metadata"><source data-testid="AssetMedia--video" src="https://openseauserdata.com/files/b3f2f72913c3b8639106d6da8921d602.mp4#t=0.001" type="video/mp4" /></video>
      </Layout>
      <Layout twocolumn color={BLACK} mdxType="Layout">
        <h1>{`y.at`}</h1>
        <p>{`emoticon url, page builder, and also web3`}</p>
        <p><a parentName="p" {...{
            "href": "https://y.at/%F0%9F%A4%98%F0%9F%8C%B2%F0%9F%8C%88%F0%9F%9B%B8"
          }}>{`https://y.at/🤘🌲🌈🛸`}</a></p>
      </Layout>
    </Split>
    <hr></hr>
    <Split mdxType="Split">
      <Layout twocolumn mdxType="Layout">
        <video autoplay="" style={{
          width: 600,
          height: 800
        }} class="AssetMedia--video" controls="" controlslist="nodownload" loop="" playsinline="" poster="https://lh3.googleusercontent.com/8LnWLNY3VelFtBgyOFoMc79c7kA-lqHPpFKG4SvJoTf1bWHVG-21LRqT5L3GF8Ws02-GPGjPWr9y06QtpmsNJgTWvFkgquENagRvWQ" preload="metadata"><source data-testid="AssetMedia--video" src="https://openseauserdata.com/files/118a15e8dc74d04e8551931943afff0e.mp4#t=0.001" type="video/mp4" /></video>
      </Layout>
      <Layout twocolumn color={BLACK} mdxType="Layout">
        <h1>{`remx`}</h1>
        <p>{`remx is a web3 platform for creatives building the future of digital wearables for the metaverse.`}</p>
        <p><a parentName="p" {...{
            "href": "https://remx.xyz/"
          }}>{`https://remx.xyz/`}</a></p>
      </Layout>
    </Split>
    <hr></hr>
    <Layout color={BRIGHT_BLUE} serif mdxType="Layout">
      <h1>{`Creator Economy`}</h1>
      <ul>
        <li parentName="ul">{`Creators can earn money from creating content`}</li>
        <li parentName="ul">{`Think: YouTube, TikTok, Spotify, Twitch, Patreon`}</li>
        <li parentName="ul">{`How much control do artists have over what they get paid and how money is exchanged?`}</li>
      </ul>
    </Layout>
    <hr></hr>
    <Layout color={BRIGHT_BLUE} serif mdxType="Layout">
      <h1>{`Creator Economy with web3`}</h1>
      <ul>
        <li parentName="ul">{`Artists are in full control`}</li>
        <li parentName="ul">{`Direct monetization`}</li>
        <li parentName="ul">{`Fairer ecosystem`}</li>
        <li parentName="ul">{`Creates community and participation`}</li>
        <li parentName="ul">{`With Apps and creator tools...`}</li>
      </ul>
    </Layout>
    <hr></hr>
    <Layout color={MAROON} mdxType="Layout">
      <h1>{`DeFi - Decentralized Finance`}</h1>
      <ul>
        <li parentName="ul">{`FinTech built on blockchain - DApps the perform financial functions`}</li>
        <li parentName="ul">{`Cryptocurrency is DeFi`}</li>
        <li parentName="ul">{`Smart Contracts as the underlying protocol `}</li>
        <li parentName="ul">{`Removes third-parties from transactions`}</li>
        <li parentName="ul">{`Further reading: Stablecoins & Central Bank Digital Currencies (CBDCs)`}</li>
      </ul>
    </Layout>
    <hr></hr>
    <Layout color={MAROON} mdxType="Layout">
      <h1>{`DeFi`}</h1>
      <ul>
        <li parentName="ul">{`Charities - Canada Learning Code first charity in Canada to receive crypto through CanadaHelps`}</li>
      </ul>
    </Layout>
    <hr></hr>
    <Layout color={MAROON} mdxType="Layout">
      <h1>{`DeFi`}</h1>
      <ul>
        <li parentName="ul">{`Asset management`}</li>
        <li parentName="ul">{`Investment`}</li>
        <li parentName="ul">{`Insurance`}</li>
        <li parentName="ul">{`Compliance, KYC, KYT`}</li>
        <li parentName="ul">{`Lending & Borrowing`}</li>
        <li parentName="ul">{`Lawyers and contracts`}</li>
      </ul>
    </Layout>
    <hr></hr>
    <Split mdxType="Split">
      <Layout twocolumn color={WHITE} light serif mdxType="Layout">
        <h1>{`MakerDao`}</h1>
        <p>{`Dai - stable, decentralized currency`}</p>
        <p><a parentName="p" {...{
            "href": "https://makerdao.com/"
          }}>{`https://makerdao.com/`}</a></p>
      </Layout>
      <Layout twocolumn color={WHITE} mdxType="Layout">
        <img src={MakerDao} style={{
          width: "600px"
        }} />
      </Layout>
    </Split>
    <hr></hr>
    <Layout color={GREEN} mdxType="Layout">
      <h1>{`ReFi - Regenerative Finance`}</h1>
      <ul>
        <li parentName="ul">{`Regenerative Economics works to regenerate capital assets (think natural assets)`}</li>
        <li parentName="ul">{`Incentivizes actions that increase systemic health`}</li>
        <li parentName="ul">{`Disincentivizes actions that lead to systemic degradation`}</li>
        <li parentName="ul">{`Redefines money within climate and justice values`}</li>
      </ul>
    </Layout>
    <hr></hr>
    <Layout color={GREEN} mdxType="Layout">
      <h1>{`ReFi - Regenerative Finance`}</h1>
      <ul>
        <li parentName="ul">{`Where web3 and carbon removal meet`}</li>
        <li parentName="ul">{`Spur action through carbon offset bridging on blockchain`}</li>
        <li parentName="ul">{`Then plastic removal, biodiversity and more`}</li>
        <li parentName="ul">{`ReFi concepts are wider yet`}</li>
      </ul>
    </Layout>
    <hr></hr>
    <Layout color={WHITE} light mdxType="Layout">
      <Image src={ImpactDaos} mdxType="Image" />
      <Footnote mdxType="Footnote">
        <p><a parentName="p" {...{
            "href": "https://public.flourish.studio/visualisation/10236878/"
          }}>{`https://public.flourish.studio/visualisation/10236878/`}</a></p>
      </Footnote>
    </Layout>
    <hr></hr>
    <Split mdxType="Split">
      <Layout twocolumn color={WHITE} light serif mdxType="Layout">
        <h1>{`Toucan`}</h1>
        <p>{`The Toucan Bridge connects the voluntary carbon market to Web3. For each credit bridged, one Tokenized CO2 token is deposited.`}</p>
        <p><a parentName="p" {...{
            "href": "https://toucan.earth/"
          }}>{`https://toucan.earth/`}</a></p>
      </Layout>
      <Layout twocolumn color={WHITE} mdxType="Layout">
        <img src={Toucan} />
      </Layout>
    </Split>
    <hr></hr>
    <Split mdxType="Split">
      <Layout twocolumn color={WHITE} light serif mdxType="Layout">
        <h1>{`Nori`}</h1>
        <p>{`Own, Track, and Showcase Verified Carbon Removal
Reverse climate change with the most transparent carbon removal marketplace`}</p>
        <p><a parentName="p" {...{
            "href": "https://nori.com/"
          }}>{`https://nori.com/`}</a></p>
      </Layout>
      <Layout twocolumn color={WHITE} mdxType="Layout">
        <img src={Nori} />
      </Layout>
    </Split>
    <hr></hr>
    <Layout color={BLUE} mdxType="Layout">
      <h1>{`The Final Word`}</h1>
      <ul>
        <li parentName="ul">{`DYOR - do your own research`}</li>
        <li parentName="ul">{`Participate - web3, nft twitter`}</li>
        <li parentName="ul">{`Buy some crypto (eth), get a wallet (metamask), buy an nft`}</li>
        <li parentName="ul">{`Participate in a DAO (get discord, just to see what's what)`}</li>
      </ul>
    </Layout>
    <hr></hr>
    <Layout color="BLACK" mdxType="Layout">
      <h1>{`Thank you 🙏`}</h1>
      <ul>
        <li parentName="ul">
          <p parentName="li"><a parentName="p" {...{
              "href": "https://www.rebel.com"
            }}>{`https://www.rebel.com`}</a></p>
        </li>
        <li parentName="ul">
          <p parentName="li"><a parentName="p" {...{
              "href": "https://twitter.com/tackaberry"
            }}>{`https://twitter.com/tackaberry`}</a></p>
        </li>
        <li parentName="ul">
          <p parentName="li"><a parentName="p" {...{
              "href": "https://www.linkedin.com/in/tackaberry/"
            }}>{`https://www.linkedin.com/in/tackaberry/`}</a></p>
        </li>
        <li parentName="ul">
          <p parentName="li"><a parentName="p" {...{
              "href": "https://github.com/tackaberry"
            }}>{`https://github.com/tackaberry`}</a></p>
        </li>
        <li parentName="ul">
          <p parentName="li"><a parentName="p" {...{
              "href": "http://impact-hub-bbl-web3-intro.s3-website.ca-central-1.amazonaws.com/"
            }}>{`This Presentation`}</a></p>
        </li>
      </ul>
    </Layout>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;